import { useState } from 'react';

export function useSaveState() {
  const [saveStatus, setSaveStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showSaveChangesModal, setShowSaveChangesModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  return {
    saveStatus, setSaveStatus,
    isLoading, setIsLoading,
    showSaveChangesModal, setShowSaveChangesModal,
    pendingNavigation, setPendingNavigation,
  };
}
